import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@design-system/i18n';
import { SocialButton } from '@design-system/social-button';
import { SocialMediaButtonLi, SocialMediaButtonUl } from './styled';
import { availableServices } from '../constants';
export const SocialMediaButtons = ({ socialMediaList, title, url, }) => {
    const { __ } = useI18n();
    const socialButtonsToRender = availableServices.filter((social) => socialMediaList.includes(social.type));
    return (_jsx(SocialMediaButtonUl, { "data-testid": "share-buttons", children: socialButtonsToRender.map((social) => (_jsx(SocialMediaButtonLi, { children: _jsx(SocialButton, Object.assign({}, social, { "aria-label": __('Share on %{platform}').i__({
                    platform: social.type,
                }), title: title, type: social.type, url: encodeURI(`${social.url + url}&text=${title}`) })) }, social.type))) }));
};
//# sourceMappingURL=SocialMediaButtons.js.map